"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var run_exports = {};
__export(run_exports, {
  runBoundsRule: () => runBoundsRule,
  runCustomRule: () => runCustomRule,
  runCustomRules: () => runCustomRules,
  runNumericRules: () => runNumericRules,
  runRequiredRule: () => runRequiredRule,
  runRequiredRules: () => runRequiredRules,
  runRules: () => runRules,
  runTimestampBoundsRule: () => runTimestampBoundsRule,
  runTimestampRules: () => runTimestampRules
});
module.exports = __toCommonJS(run_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_pass = require("./pass.js");
var import_text = require("./text.js");
function runRequiredRule(fieldType, rule, value) {
  return (0, import_pass.requiredRulePasses)(fieldType, value) ? [] : [(0, import_topo_core.createMessage)(rule.level, rule.message ?? (0, import_text.requiredRuleDefaultMessage)(rule.level))];
}
function runCustomRule(rule, env) {
  return (0, import_pass.customRulePasses)(rule.triggerWhen, env).fold(
    (e) => [(0, import_topo_core.errorMessage)(String(e))],
    (ans) => ans ? [(0, import_topo_core.createMessage)(rule.level, rule.message)] : []
  );
}
function runBoundsRule(rule, value, valueDescription = "The value") {
  if ((0, import_pass.boundsRulePasses)(rule.minValue, rule.maxValue, value)) {
    return [];
  } else {
    return [
      (0, import_topo_core.createMessage)(
        rule.level,
        rule.message ?? (0, import_text.boundsRuleDefaultMessage)(rule.level, rule.minValue, rule.maxValue, valueDescription)
      )
    ];
  }
}
function runTimestampBoundsRule(rule, value, valueDescription = "The value", now) {
  if ((0, import_pass.timestampBoundsRulePasses)(rule.minValue, rule.maxValue, value, rule.validateTime, now)) {
    return [];
  } else {
    return [
      (0, import_topo_core.createMessage)(
        rule.level,
        rule.message ?? (0, import_text.timestampBoundsRuleDefaultMessage)(
          rule.level,
          rule.minValue ?? null,
          rule.maxValue ?? null,
          rule.validateTime,
          valueDescription,
          now
        )
      )
    ];
  }
}
function runCustomRules(field, env) {
  return (field.customRules ?? []).flatMap((rule) => runCustomRule(rule, env));
}
function runRequiredRules(field, env) {
  return field.required != null ? runRequiredRule(field.type, field.required, env.getFocused()) : [];
}
function runNumericRules(field, env) {
  const value = env.getFocused();
  if (value == null) {
    return [];
  } else if (typeof value === "number") {
    return field.bounds != null ? runBoundsRule(field.bounds, value) : [];
  } else {
    return [(0, import_topo_core.errorMessage)(`Expected a number or null, found ${(0, import_util.prettyPrintJson)(value)}`, env.expand([]))];
  }
}
function runTimestampRules(field, env) {
  const value = env.getFocused();
  if (value == null) {
    return [];
  } else if ((0, import_types.isTimestamp)(value)) {
    return field.bounds != null ? runTimestampBoundsRule(
      field.bounds,
      value,
      void 0,
      env.getAbsoluteAs(["created"], import_types.isTimestamp).getOrElse(import_types.nowTimestamp)
    ) : [];
  } else {
    return [(0, import_topo_core.errorMessage)(`Expected a timestamp or null, found ${(0, import_util.prettyPrintJson)(value)}`, env.expand([]))];
  }
}
function runRules(field, env) {
  switch (field.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
    case "UserRefField":
    case "PointField":
    case "LineStringField":
    case "PolygonField":
    case "FeatureField":
    case "NearestFeatureField":
    case "Select":
    case "MultiSelect":
    case "TeamField":
      return [...runRequiredRules(field, env), ...runCustomRules(field, env)];
    case "TimestampField":
      return [...runRequiredRules(field, env), ...runTimestampRules(field, env), ...runCustomRules(field, env)];
    case "IntegerField":
    case "NumberField":
      return [...runRequiredRules(field, env), ...runNumericRules(field, env), ...runCustomRules(field, env)];
    case "Checkbox":
      return runCustomRules(field, env);
    case "AttachmentField":
      return [];
    default:
      return (0, import_util.checkExhausted)(field);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  runBoundsRule,
  runCustomRule,
  runCustomRules,
  runNumericRules,
  runRequiredRule,
  runRequiredRules,
  runRules,
  runTimestampBoundsRule,
  runTimestampRules
});
//# sourceMappingURL=run.js.map
